import { render, staticRenderFns } from "./PdfItem.vue?vue&type=template&id=58db37df&scoped=true&"
import script from "./PdfItem.vue?vue&type=script&lang=ts&"
export * from "./PdfItem.vue?vue&type=script&lang=ts&"
import style0 from "./PdfItem.vue?vue&type=style&index=0&id=58db37df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58db37df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem})
